<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" :destroy-on-close="true" append-to-body :before-close="cancel">
<!--    <el-descriptions :column="2" :labelStyle="{'width':'125px', 'font-size': '15px', 'font-weight': 'bold', 'height':'28px'}"-->
<!--                     :contentStyle="{ 'font-size': '16px', 'width':'225px'}">-->
<!--      <el-descriptions-item label="状态" :span="rejectionReason!==''?1:2">-->
<!--        <el-tag v-if="status === 'SUCCESS'" type="success">已通过</el-tag>-->
<!--        <el-tag v-else-if="status === 'APPLYING'" type="warning">待审核</el-tag>-->
<!--        <el-tag v-else-if="status === 'DEFEAT'" type="danger">已驳回</el-tag>-->
<!--        <el-tag v-else type="info">未知状态</el-tag>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item label="驳回原因" v-if="rejectionReason!==''">{{ rejectionReason }}</el-descriptions-item>-->
<!--      <el-descriptions-item label="审核时间" v-if="auditTime!==''">{{ auditTime }}</el-descriptions-item>-->
<!--      <el-descriptions-item label="审核人员" v-if="operator!==''">{{ operator }}</el-descriptions-item>-->
<!--      <el-descriptions-item label="创建人">{{ createBy }}</el-descriptions-item>-->
<!--      <el-descriptions-item label="创建时间">{{createTime}}</el-descriptions-item>-->
<!--      <el-descriptions-item label="申请人">{{salesName}}</el-descriptions-item>-->
<!--      <el-descriptions-item label="收件人">{{recipientName}}</el-descriptions-item>-->
<!--      <el-descriptions-item label="收件人电话">{{recipientPhone}}</el-descriptions-item>-->
<!--      <el-descriptions-item label="收件人地址">{{recipientAddress}}</el-descriptions-item>-->
<!--    </el-descriptions>-->
<!--    <br>-->
<!--    <el-descriptions title="申领物料信息"></el-descriptions>-->
<!--    <el-descriptions :column="2" :labelStyle="{'width':'125px', 'font-size': '15px', 'font-weight': 'bold'}" border-->
<!--                     :contentStyle="{ 'font-size': '16px', 'width':'225px'}"  v-for="(material,index) in materialRequestDetailDTOS" :key="index">-->
<!--      <el-descriptions-item label="物料名称">-->
<!--        {{material['materialLexiconDTO'].materialName}}-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item label="数量">-->
<!--        {{material.number}}-->
<!--      </el-descriptions-item>-->
<!--    </el-descriptions>-->
<!--    <br><br>-->
    <el-form label-width="120px" ref="form" :model="form" :rules="rules">
      <el-form-item label="快递单号" prop="trackingNumber">
        <scan-the-code style="width: 360px;" ref="courierNoInput" v-model="form.trackingNumber" placeholder="请扫描快递单号或者输入快递单号" :hasCleared="hasCleared"> </scan-the-code>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="title" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>

import {addTrackingNumber} from "@/api/dilivery/material/request";
import ExFoldCellToo from "@/components/ExFoldCellToo.vue";
import ScanTheCode from "@/components/scanTheCode.vue";


export default {
  name: "RequestMailDialog",
  components: {ScanTheCode, ExFoldCellToo},
  props:['showDialog','selectDetail'],
  data(){
    return{
      data:{name:'materialLexiconDTO.materialName',value:'number'},
      title:'补全物料邮寄信息',
      id:'',
      hasCleared:false,
      status: '',
      rejectionReason: '',
      operator: '',
      auditTime: '',
      salesName:'',
      recipientName: '',
      remark:'',
      createBy:'',
      createTime:'',
      materialRequestDetailDTOS:[],
      recipientAddress:'',
      recipientPhone:'',
      form:{
        id:'',
        trackingNumber:''
      },
      rules:{
        trackingNumber:[
          {required: true,message: '请输入快递单号', trigger: 'change'}
        ]
      }
    }
  },
  watch:{
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
        }
      },
      immediate:true
    },
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          addTrackingNumber(this.form).then(res => {
            if (res.code === 200) {
              this.$emit('submit','confirm')
              this.$messageUi.success('添加成功')
              this.$store.commit('right/setChangeRed',true)
            }
          }).catch(err => {
          })
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
